"use client";

import { c as _c } from "react/compiler-runtime";
import { FC, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ApiWaveOutcome } from "@/generated/models/ApiWaveOutcome";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
interface WaveManualOutcomeProps {
  readonly outcome: ApiWaveOutcome;
}
const DEFAULT_AMOUNTS_TO_SHOW = 3;
export const WaveManualOutcome: FC<WaveManualOutcomeProps> = t0 => {
  const $ = _c(50);
  const {
    outcome
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const winnersCount = outcome.distribution?.filter(_temp).length ?? 0;
  const totalCount = outcome.distribution?.length ?? 0;
  const [showAll, setShowAll] = useState(false);
  let t1;
  if ($[0] !== outcome.distribution || $[1] !== showAll) {
    t1 = () => {
      if (showAll) {
        return outcome.distribution?.map(_temp2) ?? [];
      }
      return outcome.distribution?.slice(0, DEFAULT_AMOUNTS_TO_SHOW).map(_temp3) ?? [];
    };
    $[0] = outcome.distribution;
    $[1] = showAll;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getAmounts = t1;
  let t2;
  if ($[3] !== getAmounts) {
    t2 = getAmounts();
    $[3] = getAmounts;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [amounts, setAmounts] = useState(t2);
  let t3;
  if ($[5] !== getAmounts) {
    t3 = () => {
      setAmounts(getAmounts());
    };
    $[5] = getAmounts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showAll) {
    t4 = [showAll];
    $[7] = showAll;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  const t5 = "tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-300 desktop-hover:hover:tw-border-iron-700";
  let t6;
  if ($[9] !== isOpen) {
    t6 = () => setIsOpen(!isOpen);
    $[9] = isOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = "tw-w-full tw-border-0 tw-px-4 tw-py-3 tw-bg-iron-950";
  const t8 = "tw-flex tw-items-center tw-justify-between";
  const t9 = "tw-flex tw-items-center tw-gap-4";
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="tw-flex tw-items-center tw-justify-center tw-size-10 tw-rounded-xl tw-bg-gradient-to-br tw-from-amber-400/20 tw-to-amber-600/10 tw-shadow-inner"><FontAwesomeIcon icon={faAward} className="tw-size-5 tw-text-amber-300 tw-flex-shrink-0 tw-drop-shadow-[0_0_3px_rgba(217,119,6,0.5)]" /></div>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = "tw-text-left";
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="tw-text-base tw-font-medium tw-text-amber-100">Manual</div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const t13 = "tw-text-sm tw-text-amber-300/80";
  const t14 = formatNumberWithCommas(winnersCount);
  const t15 = winnersCount === 1 ? "Winner" : "Winners";
  let t16;
  if ($[13] !== t14 || $[14] !== t15) {
    t16 = <div className={t13}>{t14}{" "}{t15}</div>;
    $[13] = t14;
    $[14] = t15;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== t12 || $[17] !== t16) {
    t17 = <div className={t11}>{t12}{t16}</div>;
    $[16] = t12;
    $[17] = t16;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t10 || $[20] !== t17) {
    t18 = <div className={t8}><div className={t9}>{t10}{t17}</div></div>;
    $[19] = t10;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="tw-text-iron-300 tw-text-sm tw-font-medium tw-mb-1">Description</div>;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  const t20 = isOpen ? 0 : -90;
  let t21;
  if ($[23] !== t20) {
    t21 = {
      rotate: t20
    };
    $[23] = t20;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  let t23;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      duration: 0.2
    };
    t23 = <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />;
    $[25] = t22;
    $[26] = t23;
  } else {
    t22 = $[25];
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t21) {
    t24 = <div className="tw-flex tw-w-full tw-justify-between tw-items-center">{t19}<motion.svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true" className="tw-flex-shrink-0 tw-size-4 tw-text-iron-400" animate={t21} transition={t22}>{t23}</motion.svg></div>;
    $[27] = t21;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  let t25;
  if ($[29] !== outcome.description) {
    t25 = <div className="tw-text-iron-400 tw-text-sm tw-overflow-x-auto tw-max-w-full tw-whitespace-nowrap tw-scrollbar-thin tw-scrollbar-track-iron-900/50 tw-scrollbar-thumb-iron-600/50">{outcome.description}</div>;
    $[29] = outcome.description;
    $[30] = t25;
  } else {
    t25 = $[30];
  }
  let t26;
  if ($[31] !== t24 || $[32] !== t25) {
    t26 = <div className="tw-mt-3 tw-flex tw-flex-col tw-items-start tw-border-t tw-border-solid tw-border-iron-800/50 tw-pt-3 tw-border-x-0 tw-border-b-0">{t24}{t25}</div>;
    $[31] = t24;
    $[32] = t25;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t18 || $[35] !== t26 || $[36] !== t6) {
    t27 = <button onClick={t6} className={t7}>{t18}{t26}</button>;
    $[34] = t18;
    $[35] = t26;
    $[36] = t6;
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  let t28;
  if ($[38] !== amounts || $[39] !== isOpen || $[40] !== outcome.distribution || $[41] !== setShowAll || $[42] !== showAll || $[43] !== totalCount) {
    t28 = isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="tw-overflow-hidden tw-bg-gradient-to-b tw-from-iron-900/50 tw-to-iron-950/50"><div className="tw-divide-y tw-divide-iron-800/30 tw-divide-solid tw-divide-x-0">{amounts.map((_, i) => <div key={`wave-manual-outcome-${outcome.distribution?.[i].amount}-${outcome.distribution?.[i].description}`} className="tw-px-4 tw-py-3 tw-bg-gradient-to-r hover:tw-from-amber-500/5 hover:tw-to-transparent tw-transition-colors tw-duration-300"><div className="tw-flex tw-items-center tw-gap-4"><span className="tw-flex tw-items-center tw-justify-center tw-size-8 tw-rounded-lg tw-bg-gradient-to-br tw-from-amber-400/10 tw-to-amber-600/5 tw-text-amber-200 tw-text-sm tw-font-semibold">{i + 1}</span><span className="tw-whitespace-nowrap tw-text-amber-100 tw-text-base tw-font-medium">{outcome.distribution?.[i].amount ? outcome.distribution?.[i].description : ""}</span></div></div>)}{totalCount > DEFAULT_AMOUNTS_TO_SHOW && !showAll && <button className="tw-border-0 tw-w-full tw-px-4 tw-py-3 tw-text-left tw-bg-iron-900 tw-text-amber-300/80 tw-text-sm hover:tw-text-amber-300 tw-transition-all tw-duration-300" onClick={() => setShowAll(true)}><span>View more</span><span className="tw-ml-1 tw-text-iron-400">•</span><span className="tw-ml-1 tw-text-iron-400">{totalCount - DEFAULT_AMOUNTS_TO_SHOW} more</span></button>}</div></motion.div>;
    $[38] = amounts;
    $[39] = isOpen;
    $[40] = outcome.distribution;
    $[41] = setShowAll;
    $[42] = showAll;
    $[43] = totalCount;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== t28) {
    t29 = <AnimatePresence initial={false}>{t28}</AnimatePresence>;
    $[45] = t28;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] !== t27 || $[48] !== t29) {
    t30 = <div className={t5}>{t27}{t29}</div>;
    $[47] = t27;
    $[48] = t29;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  return t30;
};
function _temp(d) {
  return !!d;
}
function _temp2(d_0) {
  return d_0.amount ?? 0;
}
function _temp3(d_1) {
  return d_1.amount ?? 0;
}